var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6667 1H6.33333C3.38781 1 1 3.38781 1 6.33333V43.6667C1 46.6122 3.38781 49 6.33333 49H43.6667C46.6122 49 49 46.6122 49 43.6667V6.33333C49 3.38781 46.6122 1 43.6667 1Z",
    fill: "#F7F7F8",
    stroke: "#4C4D58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8889 2H7.11111C4.28832 2 2 2.74619 2 3.66667V17C2 17.9205 4.28832 17 7.11111 17H42.8889C45.7117 17 48 17.4205 48 16.5V3.66667C48 2.74619 45.7117 2 42.8889 2Z",
    fill: "#D9D9DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6667 1H6.33333C3.38781 1 1 3.38781 1 6.33333V43.6667C1 46.6122 3.38781 49 6.33333 49H43.6667C46.6122 49 49 46.6122 49 43.6667V6.33333C49 3.38781 46.6122 1 43.6667 1Z",
    stroke: "#4C4D58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 1V49",
    stroke: "#5D5E6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17H49",
    stroke: "#5D5E6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 33H49",
    stroke: "#5D5E6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/tableIcon.5da6147cf6d086aea73b487ba70ff173.svg";
export { ForwardRef as ReactComponent };